jQuery(document).ready(function () {
  let attempts = 0;
  const maxAttempts = 20;
  const intervalTime = 300;

  function overwriteWpformsScrollFunction() {
    if (window.wpforms && typeof window.wpforms.animateScrollTop === 'function') {
      const original = window.wpforms.animateScrollTop.bind(window.wpforms);

      window.wpforms.animateScrollTop = function (position, duration, complete) {
        let offset = 0;
        jQuery.each(['#wpadminbar', '.mad-navbar__section'], function (_, selector) {
          const el = jQuery(selector);
          if (el.length) {
            offset += el.outerHeight();
          }
        });

        const newPosition = Math.max(position - offset, 0);
        return original(newPosition, duration, complete);
      };

    } else if (attempts < maxAttempts) {
      attempts++;
      setTimeout(overwriteWpformsScrollFunction, intervalTime);
    }
  }

  overwriteWpformsScrollFunction();
});

jQuery(document).ready(function () {
  var $ = jQuery;

  // --- Determine language key (simpler) ---
  var langAttr = ($('html').attr('lang') || '').toLowerCase();
  var langKey = langAttr.indexOf('-ch') !== -1 ? 'ch' : (langAttr.split('-')[0] || '');

  var map = { en: 'gb', de: 'de', ch: 'ch', fr: 'fr' };
  var target = map[langKey];
  if (!target) return;

  // --- Intl-Tel-Input setup ---
  var attempts = 0, maxAttempts = 3, interval = 200;

  function setItiCountry($input, country) {
    var input = $input[0];
    if (!input) return false;
    try {
      if (window.intlTelInputGlobals && typeof window.intlTelInputGlobals.getInstance === 'function') {
        var inst = window.intlTelInputGlobals.getInstance(input);
        if (inst && typeof inst.setCountry === 'function') { inst.setCountry(country); return true; }
      }
      if (input._iti && typeof input._iti.setCountry === 'function') { input._iti.setCountry(country); return true; }
      var dataInst = $input.data && $input.data('plugin_intlTelInput');
      if (dataInst && typeof dataInst.setCountry === 'function') { dataInst.setCountry(country); return true; }
      return false;
    } catch (e) {
      return false;
    }
  }

  function applyCountryToAll() {
    var $inputs = $('.wpforms-field-phone input[type="tel"], [data-rule-smart-phone-field="true"]');

    if (!$inputs.length) {
      if (++attempts < maxAttempts) setTimeout(applyCountryToAll, interval);
      return;
    }

    var anySet = false;
    $inputs.each(function () {
      var $input = $(this);
      if (setItiCountry($input, target)) anySet = true;
    });

    if (!anySet && ++attempts < maxAttempts) {
      setTimeout(applyCountryToAll, interval);
    }
  }

  applyCountryToAll();
});

jQuery(function ($) {

    const lang = document.documentElement.lang || 'en';

    const translations = {
        de: ['Dateien hierher ziehen', 'Dateien auswählen'],
        'de-CH': ['Dateien hierher ziehen', 'Dateien auswählen'],
        fr: ['Glissez-déposez des fichiers', 'Choisir des fichiers'],
        en: ['Drag & Drop Files', 'Choose Files to Upload']
    };

    const t = translations[lang] || translations[lang.split('-')[0]] || translations.en;

    const apply = () => {
        const $titles = $('.wpforms-uploader .modern-title');
        if ( !$titles.length ) return false;

        $titles.html(`${t[0]}, <span>${t[1]}</span>`);
        return true;
    };

    if ( apply() ) return;

    const observer = new MutationObserver(() => {
        if ( apply() ) observer.disconnect();
    });

    observer.observe(document.body, { childList: true, subtree: true });

});

